import React, {ReactElement, Component, useState, useEffect, useContext, Fragment, useMemo} from "react";
import {FormattedMessage, injectIntl} from 'react-intl';
import {withRouter} from 'react-router-dom';
import {Row, Col, Select, Skeleton, Button, Typography, Modal, Table, Dropdown, Menu} from "antd";
import {book} from '../../img';
import {http_request, response_type, destroy_worker} from "../../worker/http-func";
import {workspaces_type_item, WorkspaceContext} from "../../contexts/workspaces";
import {NamespaceContext, namespaces_type_item} from "../../contexts/namespaces";
import {select, TableListModalContext} from "../../components/table-list/table-list";
import {WorkSpaceSelectedContext} from "../../contexts/workspace-selected";
import {NameSpaceSelectedContext} from "../../contexts/namespace-selected";
import {item} from "../../contexts/items";
import {ClusterSelectedContext} from "../../contexts/cluster-selected";
import {RolesContext, role_type} from "../../contexts/roles";
import {workspacename} from "../global/global";
import './applications.less';
import {UserInfoContext, IUserInfoType} from "../../contexts/user-info";
import {clusters_type_item, ClusterContext} from "../../contexts/clusters";
import {DatacenternameContext} from "../../contexts/datacenter-name";
import {app_item} from "./applications";
import {
    LoadingOutlined,
    RightOutlined,
    DownOutlined,
    MoreOutlined,
    SyncOutlined
} from "@ant-design/icons/lib";
import AceEditor from "react-ace";
import yaml from "js-yaml";
import {ColumnsType} from "antd/lib/table";
import TableListModal from "../../components/table-list-modal/table-list-modal";
import {table_list_modal_type, TableListModalTypeContext} from "../../contexts/table_list_modal";
import {ItemSelectedContext} from "../../contexts/item-selected";
import {worker_fetch} from "../../worker/worker-fetch";
import BreadCrumb from "./component/breadCrumb";
import {loading_alert_before, loading_alert_after, alert, close_loading} from './common-file/service';
close_loading();

const {Option} = Select;

interface app_response {
    data?: any;
    error?: string | null;
    path?: string;
    status?: any;
    timestamp?: string;
    totalCount?: string | number;
    code?: number,
    index?: number,
    kind?: string,
    metadata?: any,
    spec?: any,
    Ingress?: any,
    Content?: any,
    result?: any
}

interface application_type {
    serviceInstanceName?: string,
    serviceInstanceId?: string,
    status?: string,
    serviceName?: string,
    lifecycleStatus?: string
}

export const prevent = (event: React.MouseEvent<HTMLDivElement | HTMLAnchorElement, MouseEvent>): void => {
    event.preventDefault();
    event.stopPropagation();
};

export const get_time = (date: string) => {
    return date ? `${date.slice(0, 10)} ${date.slice(11, 19)}` : '----/--/-- --:--:--'
};

const return_color = (status: string) => {
    switch (status.toLowerCase()) {
        case 'deployed':
            return 'btn-bg-success';
        case 'running':
            return 'btn-bg-success';
        case 'active':
            return 'btn-bg-success';
        case 'failed':
            return 'btn-bg-danger';
        case 'danger':
            return 'btn-bg-danger';
        case 'inactive':
            return 'btn-bg-danger';
        case 'inprogress':
            return 'btn-bg-warning';
        default:
            return 'btn-bg-default';
    }
};

export interface modal_data_type {
    visible?: boolean;
    title?: string;
    ok_btn?: boolean;
    cancel_btn?: boolean;
    is_yaml?: boolean;
    yaml_data?: object | string;
    is_update?: boolean;
    is_confirm?: boolean;
    is_scale?: boolean;
    confirm_content?: JSX.Element
}

interface version_item_type {
    name: string,
    chartversion: string,
    appversion: string,
    description: string
}

const version_compare = (ver: string, new_ver: string) => {
    const version: string[] = ver.split('.'),
        new_version: string[] = new_ver.split('.');
    let return_boolean: boolean = true;
    for (let i = 0; i < version.length; i++) {
        const ver_num: number = Number(version[i]),
            new_ver_num: number = Number(new_version[i]);
        if (ver_num > new_ver_num) {
            return_boolean = false;
            break;
        }
    }
    return return_boolean;
};

const data_service_column: ColumnsType<object> = [
    {
        title: 'Service Name',
        key: 'serviceName',
        dataIndex: 'serviceName',
        sorter: (a: any, b: any) => {
            const str_a: string = a?.serviceName || '', str_b: string = b?.serviceName || '';
            return str_a.localeCompare(str_b);
        },
        render: (val: string) => {
            return val ? {children: val, props: {'data-title': 'Service Name'}} : {}
        }
    }, {
        title: 'Plan Name',
        key: 'planName',
        dataIndex: 'planName',
        sorter: (a: any, b: any) => {
            const str_a: string = a?.serviceName || '', str_b: string = b?.serviceName || '';
            return str_a.localeCompare(str_b);
        },
        render: (val: string) => {
            return val ? {children: val, props: {'data-title': 'Plan Name'}} : {}
        }
    }, {
        title: 'Service Instance Name',
        key: 'serviceInstanceName',
        dataIndex: 'serviceInstanceName',
        sorter: (a: any, b: any) => {
            const str_a: string = a?.serviceName || '', str_b: string = b?.serviceName || '';
            return str_a.localeCompare(str_b);
        },
        render: (val: string) => {
            return val ? {children: val, props: {'data-title': 'Service Instance Name'}} : {}
        }
    }, {
        title: 'Service Instance ID',
        key: 'serviceInstanceId',
        dataIndex: 'serviceInstanceId',
        sorter: (a: any, b: any) => {
            const str_a: string = a?.serviceName || '', str_b: string = b?.serviceName || '';
            return str_a.localeCompare(str_b);
        },
        render: (val: string) => {
            return val ? {
                children: <Typography.Text copyable={{text: val}}>{val}</Typography.Text>,
                props: {'data-title': 'Service Instance ID'}
            } : {}
        }
    }
];

const operation_able: any = {
    StatefulSet: true,
    Deployment: true
};

const pods_arr: number[] = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

const application_status: any = {
    deploying: 'Deploying',
    deployed: 'Deployed',
    failed: 'Failed',
    limiting: 'Stoping',
    limited: 'Stoped',
    deleted: 'Deleted',
    active: 'Active',
    inprogress: 'In progress',
    inactive: 'Inactive',

};

// const update_btn_status: any = {
//     inprogress: true,
//     failed: true,
//     deploying: true,
//     default: true
// };

const start_stop = (data: any) => {
    // const lower_status: string = (data?.status || '').toLowerCase(),
    //     is_limited: number = data?.isLimited || 0;
    // switch (lower_status) {
    //     case 'deployed':
    //         return is_limited === 1 ? 'start' : 'stop';
    //     default:
    //         return false;
    // }
    return data === 'Stopped' ? 'start': 'stop';
};

const status_return_boolean = (detail: application_type)=>{
    return (detail && detail?.lifecycleStatus !== 'Inprogess')
};

const ApplicationsDetail: React.FC = (props: any): ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null => {
        const [workspace_selected, set_workspace_selected]: [item | undefined, React.Dispatch<React.SetStateAction<item | undefined>>] = useContext(WorkSpaceSelectedContext),
            [namespace_selected, set_namespace_selected]: [item | undefined, React.Dispatch<React.SetStateAction<item | undefined>>] = useContext(NameSpaceSelectedContext),
            [table_list_modal, set_table_list_modal]: [table_list_modal_type, React.Dispatch<React.SetStateAction<table_list_modal_type>>] = useContext(TableListModalTypeContext),
            [modal_data, set_modal_data]: [modal_data_type, React.Dispatch<React.SetStateAction<modal_data_type>>] = useState({}),
            user_info: IUserInfoType = useContext(UserInfoContext)[0],
            [select_menu, set_select_menu]: [JSX.Element, React.Dispatch<React.SetStateAction<JSX.Element>>] = useState<JSX.Element>(
                <p/>),
            roles: role_type[] = useContext(RolesContext)[0],
            [workspaces, set_workspaces]: [workspaces_type_item[] | undefined, React.Dispatch<React.SetStateAction<workspaces_type_item[] | undefined>>] = useContext(WorkspaceContext),
            [namespaces, set_namespaces]: [namespaces_type_item[] | undefined, React.Dispatch<React.SetStateAction<namespaces_type_item[] | undefined>>] = useContext(NamespaceContext),
            cluster_selected: item | undefined = useContext(ClusterSelectedContext)[0],
            clusters: clusters_type_item[] = useContext(ClusterContext)[0],
            set_cluster_selected: React.Dispatch<React.SetStateAction<item | undefined>> = useContext(ClusterSelectedContext)[1],
            datacenter_name: string | undefined = useContext(DatacenternameContext)[0],
            path: string = props.history.location.pathname.substring(1),
            [application_selected, set_application_selected]: [application_type, React.Dispatch<React.SetStateAction<application_type>>] = useState(JSON.parse(sessionStorage.getItem('application_instance') || '{}')),
            [application_detail, set_application_detail]: [any, React.Dispatch<React.SetStateAction<any>>] = useState(null),
            [reload_detail, set_reload_detail]: [boolean, React.Dispatch<React.SetStateAction<boolean>>] = useState(() => false),
            [apps_list, set_apps_list]: [any, React.Dispatch<React.SetStateAction<any>>] = useState(null),
            [data_service_selected, set_data_service_selected]: [any, React.Dispatch<React.SetStateAction<any>>] = useState([]),
            [workload, set_workload]: [any, React.Dispatch<React.SetStateAction<any>>] = useState([]),
            [version_list, set_version_list]: [any, React.Dispatch<React.SetStateAction<any>>] = useState(null),
            [update_version, set_update_version]: [string, React.Dispatch<React.SetStateAction<string>>] = useState('Empty'),
            [modal_loading, set_modal_loading]: [boolean, React.Dispatch<React.SetStateAction<boolean>>] = useState(() => false),
            [reload, set_reload]: [boolean, React.Dispatch<React.SetStateAction<boolean>>] = useState(() => false),
            [reload_workload, set_reload_workload]: [boolean, React.Dispatch<React.SetStateAction<boolean>>] = useState(() => false),
            [pods_list, set_pods_list]: [any, React.Dispatch<React.SetStateAction<any>>] = useState([]),
            [pods_data, set_pods_data]: [any, React.Dispatch<React.SetStateAction<any>>] = useState(null),
            [table_item_selected, set_table_item_selected]: [any, React.Dispatch<React.SetStateAction<any>>] = useState({}),
            [scale_number, set_scale_number]: [number, React.Dispatch<React.SetStateAction<number>>] = useState(0),
            [is_first, set_is_first]: [boolean, React.Dispatch<React.SetStateAction<boolean>>] = useState<boolean>(true),
            [can_update, set_can_update]: [boolean, React.Dispatch<React.SetStateAction<boolean>>] = useState<boolean>(false),
            [app_actualStatus, set_app_actualStatus]: [string, React.Dispatch<React.SetStateAction<string>>] = useState<string>(''),
            {history} = props,
            {formatMessage} = useMemo(() => props.intl, [props]),
            set_item_selected: React.Dispatch<React.SetStateAction<item>> = useContext(ItemSelectedContext)[1];

        useEffect(() => () => {
            destroy_worker()
        }, []);

        useEffect(() => {
            if (is_first) {
                set_is_first(false);
                set_cluster_selected({name: 'all'});
                set_workspace_selected({name: 'all'});
                set_namespace_selected({name: 'all'});
                sessionStorage.setItem("cluster", 'all');
            }
            // eslint-disable-next-line
        }, [cluster_selected]);

        useEffect((): void => {
            if (application_selected.serviceInstanceId && reload_detail) {
                reload_detail && set_reload_detail(false);
                (async () => {
                    loading_alert_before();
                    const {data}: any = await worker_fetch({
                        url: `/appBuy/serviceInstances/${application_selected.serviceInstanceId}/instances`,
                        method: 0,
                        props: {formatMessage, history},
                        datacenter_name
                    }) || {};
                    if (data?.data?.[0]) {
                        set_application_detail(data?.data[0]);
                        set_update_version(data?.data[0].versionName);
                        set_workload([])
                    } else {
                        set_application_detail(null);
                    }
                    loading_alert_after();
                })()
            } else {
                set_application_detail(null);
            }
            // eslint-disable-next-line
        }, [application_selected, reload_detail]);

        useEffect(()=>{
            if(application_selected.serviceInstanceId){
                (async ()=>{
                    loading_alert_before();
                    const {data}: any = await worker_fetch({
                        url: `/appBuy/serviceInstances/${application_selected.serviceInstanceId}/status`,
                        method: 0,
                        props: {formatMessage, history},
                        datacenter_name
                    }) || {};
                    const status: any = data.data || [];
                    if(status.length>0){
                        set_app_actualStatus(status[0].actualStatus);
                        set_can_update(status[0].canUpdate);
                    }
                    loading_alert_after();
                })()
            }
            // eslint-disable-next-line
        }, [application_selected, set_app_actualStatus, set_can_update]);

        useEffect((): void => {
            reload && set_workload([]);
            if (application_selected.serviceInstanceId && application_detail && reload) {
                set_reload(false);
                (async () => {
                    const {data}: any = await worker_fetch({
                        url: `/v1/datacenter/${datacenter_name}/cluster/${application_detail?.clusterName || ''}/namespace/${application_detail?.namespaceName || ''}/workload`,
                        method: 0,
                        props: {formatMessage, history},
                        datacenter_name
                    }) || {};
                    if (data) {
                        set_pods_list(data);
                        set_reload_workload(true);
                    }
                })()
            }
            // eslint-disable-next-line
        }, [application_selected, application_detail, reload]);

        useEffect((): void => {
            if (application_detail && reload_workload) {
                (async () => {
                    const {name, subscriptionId, datacenterCode, clusterName, workspaceId, namespaceName} = application_detail;
                    const {data}: any = await worker_fetch({
                        url: `/appBuy/helmReleases/${name}/status?subscriptionId=${subscriptionId}&datacenterCode=${datacenterCode}&clusterName=${clusterName}&workspaceId=${workspaceId}&namespaceName=${namespaceName}`,
                        method: 0,
                        props: {formatMessage, history},
                        datacenter_name
                    }) || {};
                    if (data?.data?.resources) {
                        const {deployment, daemonSet, statefulSet} = data.data.resources || {};
                        let list: any = [];
                        deployment?.map((item: any, key: number) => list.push({
                            key: `deployment${key}`,
                            type: 'Deployment', ...(item || {})
                        }));
                        daemonSet?.map((item: any, key: number) => list.push({
                            key: `deployment${key}`,
                            type: 'DaemonSet', ...(item || {})
                        }));
                        statefulSet?.map((item: any, key: number) => list.push({
                            key: `deployment${key}`,
                            type: 'StatefulSet', ...(item || {})
                        }));
                        set_workload(list)
                    } else {
                        set_workload([]);
                    }
                    set_reload_workload(false)
                })()
            }
            // eslint-disable-next-line
        }, [application_detail, reload_workload]);

        useEffect((): void => {
            if (clusters?.length > 0) {
                // const data: string = sessionStorage.getItem("cluster") || "all",
                //     selected = Array.isArray(clusters) && clusters.find((cluster: clusters_type_item) => cluster.metadata && cluster.metadata.name === data);
                // if (selected) set_cluster_selected(selected.metadata);
                // else {
                set_cluster_selected({name: 'all'});
                set_workspace_selected({name: 'all'});
                set_namespace_selected({name: 'all'});
                sessionStorage.setItem("cluster", 'all');
                // }
            }
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [clusters, set_cluster_selected]);

        useEffect((): void => {
            if (workspaces && Array.isArray(workspaces)) {
                // const data: string = sessionStorage.getItem("workspace") || "all";
                // const selected = workspaces?.find((workspace: workspaces_type_item) => workspace.metadata && workspace.metadata.name === data);
                // if (selected) set_workspace_selected(selected.metadata);
                // else {
                set_workspace_selected({name: 'all'});
                set_namespace_selected({name: 'all'});
                sessionStorage.setItem("workspace", 'all');
                // }
            }
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [workspaces, set_workspace_selected]);

        useEffect((): void => {
            if (!path.includes("monitor") && namespaces) {
                // const data: string = sessionStorage.getItem("namespace") || "all",
                //     selected = Array.isArray(namespaces) && namespaces.find((namespace: namespaces_type_item) => namespace.metadata?.name === data);
                // if (selected) set_namespace_selected(selected.metadata);
                // else {
                set_namespace_selected({name: 'all'});
                sessionStorage.setItem("namespace", 'all');
                // }
            }
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [set_namespace_selected, namespaces, workspace_selected]);

        useEffect((): void => {
            (async () => {
                if (cluster_selected?.name && cluster_selected.name !== 'all' && datacenter_name) {
                    set_workspaces(undefined);
                    set_workspace_selected(undefined);
                    set_namespaces(undefined);
                    set_namespace_selected(undefined);
                    // sessionStorage.removeItem('namespace');
                    const {name}: item = cluster_selected;
                    if ((user_info.role === "workspaceOwner" && user_info.wkOwner_has_namespacedeveloper.includes(cluster_selected?.name)) || user_info.role === 'namespaceDeveloper') {
                        const workspacenames: workspacename[] = (await http_request(
                            'workspacenames',
                            props,
                            undefined,
                            `/v1/datacenter/${datacenter_name}/cluster/${cluster_selected.name}/workspacenames`,
                            0,
                            user_info.role,
                            user_info.subscription_id,
                            datacenter_name,
                            cluster_selected.name || '',
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            true
                        ) as response_type).items as workspacename[];
                        workspacenames && set_workspaces(workspacenames.map(({name, id}: workspacename) => {
                            return {metadata: {name: id, labels: {name}}} as workspaces_type_item
                        }));
                    } else {
                        name && http_request(
                            'workspaces',
                            props,
                            set_workspaces,
                            `/v1/datacenter/${datacenter_name}/cluster/${cluster_selected.name}/workspaces`,
                            0,
                            user_info.role,
                            user_info.subscription_id,
                            datacenter_name,
                            cluster_selected.name || '',
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            true
                        );
                    }
                }
            })();
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [cluster_selected?.name, user_info.role, user_info.subscription_id, user_info.wkOwner_has_namespacedeveloper]);

        useEffect((): void => {
            if (user_info.role !== '' && cluster_selected?.name && cluster_selected.name !== 'all' && workspace_selected?.name && workspace_selected.name !== 'all' && datacenter_name) {
                const name = workspace_selected.name;
                name && http_request(
                    'namespaces',
                    props,
                    set_namespaces,
                    `/v1/datacenter/${datacenter_name}/cluster/${cluster_selected.name}/workspace/${name}/namespaces`,
                    0,
                    user_info.role,
                    user_info.subscription_id,
                    datacenter_name,
                    cluster_selected.name,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    true
                );
            }
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [workspace_selected && workspace_selected.name, user_info.role, user_info.subscription_id, set_namespaces]);

        const load_app_list = async () => {
            const name = namespace_selected?.name,
                cname = cluster_selected?.name,
                wkname = workspace_selected?.name;
            const {data}: any = await worker_fetch({
                url: `/appBuy/serviceInstances?subscriptionId=${user_info.subscription_id}&datacenterCode=${datacenter_name}&clusterName=${(cname !== 'all') ? cname : ''}&workspaceId=${(wkname !== 'all') ? wkname : ''}&namespaceName=${(name !== 'all') ? name : ''}`,
                method: 0,
                props: {formatMessage, history},
                datacenter_name
            }) || {};
            if (data?.data) {
                const filter_list: any = (data?.data || []).filter(({lifecycleStatus}: application_type) => (lifecycleStatus || '').toLowerCase() === 'active');
                if (filter_list[0]) {
                    const session_app: application_type = JSON.parse(sessionStorage.getItem('application_instance') || '{}'),
                        selected_filter: any[] = filter_list.filter((item: application_type) => item.serviceInstanceId === session_app?.serviceInstanceId);
                    if (selected_filter.length <= 0) {
                        const {serviceName, serviceInstanceName, serviceInstanceId, lifecycleStatus} = filter_list[0];
                        const app_selected: application_type = {
                            serviceInstanceName,
                            serviceInstanceId,
                            serviceName,
                            status: lifecycleStatus
                        };
                        set_application_selected(app_selected);
                        set_reload_detail(true);
                        sessionStorage.setItem('application_instance', JSON.stringify(app_selected));
                        set_data_service_selected(filter_list[0]?.appServiceInfo?.dependencyServices?.dataServices || [])
                    } else {
                        const {serviceName, serviceInstanceName, serviceInstanceId, lifecycleStatus} = selected_filter[0];
                        const app_selected: application_type = {
                            serviceInstanceName,
                            serviceInstanceId,
                            serviceName,
                            status: lifecycleStatus
                        };
                        set_application_selected(app_selected);
                        set_reload_detail(true);
                        sessionStorage.setItem('application_instance', JSON.stringify(app_selected));
                        set_data_service_selected(selected_filter[0]?.appServiceInfo?.dependencyServices?.dataServices || [])
                    }
                } else {
                    set_application_selected({});
                    sessionStorage.setItem('application_instance', '{}');
                    set_data_service_selected([])
                }
                set_apps_list(filter_list);
            } else {
                set_apps_list([]);
                set_application_selected({});
                set_data_service_selected([])
            }
            set_reload(true);
        };

        useEffect((): void => {
            if (cluster_selected?.name && namespace_selected?.name && workspace_selected?.name && datacenter_name && user_info.subscription_id) {
                load_app_list();
            }
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [user_info.subscription_id, datacenter_name, cluster_selected?.name, workspace_selected?.name, namespace_selected?.name]);

        useEffect((): void => {
            set_pods_data(null);
            if (pods_list.length > 0 && workload.length > 0) {
                (async () => {
                    const pod_obj: any = {};
                    for (let i = 0; i < workload.length; i++) {
                        const {name, type} = workload[i] || {},
                            filter = pods_list.filter((item: any) => item.name === name && item.type === type),
                            podNames = (filter[0] || {})?.podNames || [],
                            unhealthyPodNames = (filter[0] || {}).unhealthyPodNames || [],
                            new_list = [];
                        const new_pod: string[] = podNames.concat(unhealthyPodNames);
                        if (new_pod?.length > 0) {
                            for (let i = 0; i < new_pod.length; i++) {
                                const {data}: any = await worker_fetch({
                                    url: `/v1/datacenter/${datacenter_name}/cluster/${application_detail?.clusterName}/namespace/${application_detail?.namespaceName}/pod/${new_pod[i]}`,
                                    method: 0,
                                    props: {formatMessage, history},
                                    datacenter_name
                                }) || {};
                                if (data && data.Content) {
                                    const {name, creationTimestamp} = data.Content?.metadata || {},
                                        {nodeName, containers} = data.Content?.spec || {},
                                        {phase, containerStatuses} = data.Content?.status || {},
                                        {restartCount} = containerStatuses?.[0] || 0;
                                    new_list.push({
                                        status: phase,
                                        name,
                                        ready: `${phase === 'Running' ? 1 : 0}/1`,
                                        restarts: restartCount,
                                        age: creationTimestamp,
                                        node: nodeName,
                                        containers: containers?.[0]?.name || ''
                                    })
                                }
                            }
                            // console.log(new_list)
                            pod_obj[name] = new_list;
                        } else {
                            pod_obj[name] = []
                        }
                    }
                    set_pods_data(pod_obj)
                })()
            }
            // eslint-disable-next-line
        }, [pods_list, workload]);

        useEffect((): void => {
            set_select_menu(
                <Fragment>
                    <Col sm={6} className="px-6">
                        <Row>
                        <span title='cluster' className='text-white font-w-6 text-center'><FormattedMessage id="cluster"/></span>
                            <Select
                                size="large"
                                style={{width: '100%', paddingLeft: 2}}
                                className={'font-bold-blue'}
                                getPopupContainer={(node: any)=> node.parentNode}
                                showSearch
                                optionFilterProp="children"
                                value={cluster_selected ? cluster_selected.name : roles.find((r: role_type) => r.cluster === sessionStorage.getItem('cluster'))?.cluster || 'all'}
                                onChange={(event: string) => {
                                    set_cluster_selected((event === 'all') ? {name: 'all'} : (clusters.find((cluster: clusters_type_item) => cluster.metadata.name === event) || {}).metadata);
                                    set_workspaces(undefined);
                                    set_namespaces(undefined);
                                    set_workspace_selected({name: 'all'});
                                    set_namespace_selected({name: 'all'});
                                    sessionStorage.removeItem('workspace');
                                    sessionStorage.removeItem('namespace');
                                    sessionStorage.setItem('cluster', event);
                                    set_application_selected({});
                                    set_apps_list([]);
                                    set_workload([]);
                                    set_data_service_selected([]);
                                    set_pods_list([]);
                                    sessionStorage.setItem('application_instance', '{}');
                                }}
                            >
                                <Option key={'all'} value={'all'}>
                                    <span className={'font-bold-blue'}>
                                        <FormattedMessage id={'all'}/>
                                    </span>
                                </Option>
                                {clusters?.length && Array.isArray(clusters) && clusters.map((cluster: clusters_type_item) =>
                                    <Option
                                        key={cluster.metadata.name}
                                        value={cluster.metadata.name}
                                    >{cluster.metadata.name}</Option>)
                                }
                            </Select>
                        </Row>
                    </Col>
                    <Col sm={6} className="px-6">
                        <Row>
                        <span title="workspace" className='text-white font-w-6 text-center'><FormattedMessage id="workspace"/></span>
                            <Select
                                size="large"
                                showSearch
                                optionFilterProp="children"
                                value={workspace_selected?.labels ? workspace_selected.labels.name : 'all'}
                                style={{width: '100%', paddingLeft: 2}}
                                className={'font-bold-blue'}
                                getPopupContainer={(node: any)=> node.parentNode}
                                onChange={(event: string) => {
                                    if (event === 'all') {
                                        set_workspace_selected({name: 'all'});
                                        set_namespace_selected({name: 'all'});
                                        sessionStorage.setItem("workspace", 'all');
                                        sessionStorage.removeItem('namespace');
                                    } else select(event, set_workspace_selected, true, workspaces);
                                    set_namespaces(undefined);
                                    set_application_selected({});
                                    set_apps_list([]);
                                    set_workload([]);
                                    set_data_service_selected([]);
                                    set_pods_list([]);
                                    sessionStorage.setItem('application_instance', '{}')
                                }}
                            >
                                <Option className={'font-bold-blue'} key={'all'} value={'all'}>
                                    <span className={'font-bold-blue'}>
                                        <FormattedMessage id={'all'}/>
                                    </span>
                                </Option>
                                {workspaces?.map((workspace: workspaces_type_item) =>
                                    <Option
                                        key={workspace?.metadata.uid}
                                        value={workspace?.metadata?.labels?.name}
                                    >{workspace?.metadata?.labels?.name}</Option>)
                                }
                            </Select>
                        </Row>
                    </Col>
                    <Col sm={6} className="px-6">
                        <Row>
                        <span title="namespace" className='text-white font-w-6 text-center'><FormattedMessage id="namespace"/></span>
                            <Select
                                size="large"
                                showSearch
                                optionFilterProp="children"
                                value={namespace_selected && namespace_selected.name ? namespace_selected.name : (namespaces && namespaces[0] && namespaces[0].metadata.name) || 'Empty'}
                                style={{width: '100%', paddingLeft: 2}}
                                className={'font-bold-blue'}
                                getPopupContainer={(node: any)=> node.parentNode}
                                onChange={(event: string) => {
                                    if (event === 'all') {
                                        set_namespace_selected({name: 'all'});
                                        sessionStorage.setItem("namespace", 'all');
                                    } else select(event, set_namespace_selected, false, namespaces);
                                    set_application_selected({});
                                    set_apps_list([]);
                                    set_workload([]);
                                    set_data_service_selected([]);
                                    set_pods_list([]);
                                    sessionStorage.setItem('application_instance', '{}')
                                }}
                            >
                                <Option className={'font-bold-blue'} key={'all'} value={'all'}>
                                    <span className={'font-bold-blue'}>
                                        <FormattedMessage id={'all'}/>
                                    </span>
                                </Option>
                                {namespaces && namespaces.map((namespace: namespaces_type_item) =>
                                    <Option
                                        key={namespace.metadata.uid}
                                        value={namespace.metadata.name}
                                    >{namespace.metadata.name}</Option>)
                                }
                            </Select>
                        </Row>
                    </Col>
                    <Col sm={6} className="px-6">
                        <Row>
                        <span title={formatMessage({id: 'applications'})}
                              className='text-white font-w-6 text-center'><FormattedMessage id="applications"/></span>
                            <Select size="large" showSearch optionFilterProp="children"
                                    value={apps_list?.length > 0 ? application_selected.serviceInstanceId : 'Empty' || 'Empty'}
                                    style={{width: '100%', paddingLeft: 2}}
                                    className={'font-bold-blue'}
                                    getPopupContainer={(node: any)=> node.parentNode}
                                    onChange={(event: string) => {
                                        const selected: any = apps_list.filter((app: app_item) => app.serviceInstanceId === event),
                                            {dataService, serviceInstanceName, serviceInstanceId, serviceName, lifecycleStatus} = selected[0] || {},
                                            app_selected: application_type = {
                                                serviceInstanceName,
                                                serviceInstanceId,
                                                serviceName,
                                                status: lifecycleStatus
                                            };
                                        set_application_selected(app_selected);
                                        set_application_detail(null);
                                        set_reload_detail(true);
                                        set_reload(true);
                                        set_workload([]);
                                        set_data_service_selected([]);
                                        // set_pods_list([]);
                                        sessionStorage.setItem('application_instance', JSON.stringify(app_selected));
                                        set_data_service_selected(dataService || [])
                                    }}
                            >
                                {apps_list && apps_list.map(({serviceInstanceName, serviceInstanceId}: app_item) =>
                                    <Option key={serviceInstanceId}
                                            value={serviceInstanceId}>{serviceInstanceName}</Option>)}
                            </Select>
                        </Row>
                    </Col>
                </Fragment>)
        }, [namespace_selected, namespaces, workspace_selected, workspaces, cluster_selected, clusters, apps_list, application_selected, set_cluster_selected, set_namespace_selected, set_workspace_selected, set_workspaces, set_namespaces, roles, formatMessage]);

        const get_version_list = async () => {
            const {chartRepoId, chartname} = application_detail;
            const {data}: any = await worker_fetch({
                url: `/appBuy/chartrepos/${chartRepoId}/charts/${chartname}/versions`,
                method: 0,
                props: {formatMessage, history},
                datacenter_name
            }) || {};
            data?.data && set_version_list(data.data);
        };

        const on_btn_click = async () => {
            set_modal_loading(true);
            if (modal_data?.is_update) {
                if (update_version !== application_detail?.versionName) {
                    const {id, chartname, yamlFile, extraArgs, isWait, dockerUsername, dockerPassword, dockerServerUrl} = application_detail;
                    const request_body = {
                        chartName: chartname,
                        versionName: update_version,
                        yamlFile,
                        extraArgs,
                        isWait,
                        dockerUsername,
                        dockerPassword,
                        dockerServerUrl
                    };
                    const {data}: app_response = await http_request(
                        'application_list',
                        props,
                        undefined,
                        `/appBuy/subscriptions/${id}`,
                        2,
                        'globalAdmin',
                        undefined,
                        '',
                        '',
                        request_body,
                        undefined,
                        undefined,
                        undefined,
                        true
                    ) as app_response || {};
                    if (data) {
                        set_reload(true);
                        set_modal_data({visible: false});
                    }
                } else {
                    set_modal_data({visible: false})
                }
            } else if (modal_data?.is_confirm) {
                switch (modal_data?.title) {
                    case 'redeploy':
                        const redeploy: any = await worker_fetch({
                            url: `/appBuy/serviceInstances/${application_detail?.appServiceInstanceId}/redeploy`,
                            method: 2,
                            props: {formatMessage, history},
                            datacenter_name,
                            warning: false
                        });
                        if (redeploy.status === 201) {
                            set_reload_detail(true);
                            set_reload(true);
                            set_modal_data({visible: false});
                            alert('success', formatMessage({id: modal_data.title}), formatMessage({id: 'redeploy_success'}))
                        }else {
                            set_modal_data({visible: false});
                            alert('error', formatMessage({id: modal_data.title}), `${redeploy.status}: ${redeploy.data.error}`)
                        }
                        break;
                    case 'start':
                        const start: any = await worker_fetch({
                            url: `/appBuy/subscriptions/${application_detail?.id}/resume`,
                            method: 4,
                            props: {formatMessage, history},
                            datacenter_name,
                            warning: false
                        });
                        if (start.status === 201) {
                            set_reload_detail(true);
                            set_reload(true);
                            set_modal_data({visible: false});
                            alert('success', formatMessage({id: modal_data.title}), formatMessage({id: 'start_success'}))
                        }else {
                            set_modal_data({visible: false});
                            alert('error', formatMessage({id: modal_data.title}), `${start.status}: ${start.data.error}`)
                        }
                        break;
                    case 'stop':
                        const stop: any = await worker_fetch({
                            url:`/appBuy/subscriptions/${application_detail?.id}/limit`,
                            method: 4,
                            props: {formatMessage, history},
                            datacenter_name,
                            warning: false
                        });
                        if (stop.status === 201) {
                            set_reload_detail(true);
                            set_reload(true);
                            set_modal_data({visible: false});
                            alert('success', formatMessage({id: modal_data.title}), formatMessage({id: 'stop_success'}))
                        }else {
                            set_modal_data({visible: false});
                            alert('error', formatMessage({id: modal_data.title}), `${stop.status}: ${stop.data.error}`)
                        }
                        break;
                    case 'update':
                        const update: any = await worker_fetch({
                            url: `/appBuy/serviceInstances/${application_detail?.appServiceInstanceId}/update`,
                            method: 2,
                            props: {formatMessage, history},
                            datacenter_name,
                            warning: false
                        });
                        if (update.status === 201) {
                            set_reload_detail(true);
                            set_reload(true);
                            set_modal_data({visible: false});
                            alert('success', formatMessage({id: modal_data.title}), formatMessage({id: 'update_success'}))
                        }else {
                            set_modal_data({visible: false});
                            alert('error', formatMessage({id: modal_data.title}), `${update.status}: ${update.data.error}`)
                        }
                        break;
                    default:
                        break;
                }
            } else if (modal_data?.is_scale) {
                const {type, name} = table_item_selected;
                const scale: any = await worker_fetch({
                    url: `/v1/datacenter/${datacenter_name}/cluster/${application_detail.clusterName}/namespace/${application_detail.namespaceName}/${type.toLowerCase()}/${name}/replica/${scale_number}`,
                    method: 2,
                    props: {formatMessage, history},
                    datacenter_name,
                    warning: false
                });
                if (scale.status === 201 || scale.status === 200) {
                    set_reload(true);
                    set_modal_data({visible: false});
                    alert('success', formatMessage({id: modal_data.title}), formatMessage({id: 'scale_success'}))
                }else {
                    set_modal_data({visible: false});
                    alert('error', formatMessage({id: modal_data.title}), `${scale.status}: ${scale.data.error}`)
                }
            } else {
                set_modal_data({visible: false})
            }
            set_modal_loading(false)
        };

        const view_pod_yaml = async (item: any) => {
            set_modal_data({
                title: 'view',
                visible: true,
                is_yaml: true,
                yaml_data: 'Loading...'
            });
            const {data}: any = await worker_fetch({
                url: `/v1/datacenter/${datacenter_name}/cluster/${application_detail.clusterName}/namespace/${application_detail.namespaceName}/pod/${item.name}`,
                method: 0,
                props: {formatMessage, history},
                datacenter_name
            }) || {};
            set_modal_data({
                title: 'view',
                visible: true,
                is_yaml: true,
                yaml_data: data?.Content || 'Loading failed'
            });
        };

        const expended_table = (record: any) => {
            const expended_columns: ColumnsType<object> = [
                {
                    title: 'Status',
                    key: 'status',
                    dataIndex: 'status',
                    sorter: (a: any, b: any) => {
                        const str_a: string = a?.status || '', str_b: string = b?.status || '';
                        return str_a.localeCompare(str_b);
                    },
                    render: (val: string) => {
                        return val ? {
                            children: <span title={val || '---'}
                                            className={`table-btn-status text-ellipsis ${return_color(val === 'Running' ? val : 'danger')}`}>{val || '---'}</span>,
                            props: {'data-title': 'Status'}
                        } : {}
                    }
                },
                {
                    title: 'Name',
                    key: 'name',
                    dataIndex: 'name',
                    sorter: (a: any, b: any) => {
                        const str_a: string = a?.name || '', str_b: string = b?.name || '';
                        return str_a.localeCompare(str_b);
                    },
                    render: (val: string) => {
                        return val ? {children: val, props: {'data-title': 'Name'}} : {}
                    }
                },
                {
                    title: 'Ready',
                    key: 'ready',
                    dataIndex: 'ready',
                    sorter: (a: any, b: any) => {
                        const str_a: string = a?.ready || '', str_b: string = b?.ready || '';
                        return str_a.localeCompare(str_b);
                    },
                    render: (val: string) => {
                        return val ? {children: val, props: {'data-title': 'Ready'}} : {}
                    }
                },
                {
                    title: 'Restarts',
                    key: 'restarts',
                    dataIndex: 'restarts',
                    sorter: (a: any, b: any) => {
                        const str_a: string = a?.restarts || '', str_b: string = b?.restarts || '';
                        return str_a.localeCompare(str_b);
                    },
                    render: (val: string) => {
                        return {children: val, props: {'data-title': 'Restarts'}}
                    }
                },
                {
                    title: 'Age',
                    key: 'age',
                    dataIndex: 'age',
                    sorter: (a: any, b: any) => {
                        const str_a: string = a?.age || '', str_b: string = b?.age || '';
                        return str_a.localeCompare(str_b);
                    },
                    render: (val: string) => {
                        return val ? {children: val, props: {'data-title': 'Age'}} : {}
                    }
                },
                {
                    title: 'Node',
                    key: 'node',
                    dataIndex: 'node',
                    sorter: (a: any, b: any) => {
                        const str_a: string = a?.node || '', str_b: string = b?.node || '';
                        return str_a.localeCompare(str_b);
                    },
                    render: (val: string) => {
                        return val ? {children: val, props: {'data-title': 'Node'}} : {}
                    }
                },
                {
                    title: formatMessage({id: 'operation'}),
                    key: 'action',
                    width: 100,
                    render: (item: any) => item ? {
                        children: (
                            <Dropdown
                                overlay={(
                                    <Menu className="small_dropdown setting-dropdown">
                                        <Menu.Item>
                                            <div className="pointer hover" onClick={() => {
                                                const {clusterName, namespaceName} = application_detail;
                                                set_item_selected({
                                                    podNames: [item.name],
                                                    app_cluster: clusterName,
                                                    app_namespace: namespaceName,
                                                    containers: item.containers
                                                });
                                                set_table_list_modal((currentState) => ({
                                                    ...currentState,
                                                    visible: true,
                                                    is_logs: true,
                                                    modal_ok_button: false,
                                                    logs_data: {
                                                        clusterName,
                                                        namespaceName
                                                    }
                                                }));
                                            }}>
                                                <Button className="plain_button w-100">
                                                    <FormattedMessage id="log"/>
                                                </Button>
                                            </div>
                                        </Menu.Item>
                                        <Menu.Item>
                                            <div className="pointer hover"
                                                 onClick={() => window.open('/monitor', '_blank')}>
                                                <Button className="plain_button w-100">
                                                    <FormattedMessage id="monitor"/>
                                                </Button>
                                            </div>
                                        </Menu.Item>
                                        <Menu.Item>
                                            <div className="pointer hover" onClick={() => view_pod_yaml(item)}>
                                                <Button className="plain_button w-100">
                                                    <FormattedMessage id="view_in_yaml"/>
                                                </Button>
                                            </div>
                                        </Menu.Item>
                                    </Menu>
                                )}
                                trigger={['click']}
                                placement="bottomCenter"
                            >
                                <Button
                                    className="plain_button d-flex align-items-center justify-between"
                                    onClick={() => set_table_item_selected(item)}
                                >
                                    <MoreOutlined/>
                                </Button>
                            </Dropdown>
                        ),
                        props: {'data-title': 'Operation'}
                    } : {}
                }
            ];
            // const [pods, set_pods]: [any, React.Dispatch<React.SetStateAction<any>>] = useState(null);
            const {name} = record || {};
            return <div>
                <h4>Pods:</h4>
                <Table
                    rowKey={({name}: any) => name}
                    columns={expended_columns}
                    dataSource={pods_data ? pods_data[name] || [] : []} size={'small'}
                    showSorterTooltip={false}
                    pagination={false}
                />
            </div>
        };

        const open_router_modal = async (router: string) => {
            set_table_list_modal((currentState) => ({
                ...currentState,
                visible: true,
                is_details: true,
                modal_ok_button: false
            }));
            const {data}: any = await worker_fetch({
                url: `/v1/datacenter/${datacenter_name}/cluster/${application_detail.clusterName}/namespace/${application_detail.namespaceName}/router/${router}`,
                method: 0,
                props: {formatMessage, history},
                datacenter_name
            }) || {};
            if (data?.Content) {
                const {name, namespace, creationTimestamp, labels, annotations,} = data?.Content?.metadata || {},
                    {ingress} = data?.Content?.status?.loadBalancer || [],
                    {rules} = data?.Content?.spec || [];
                const new_rules: any = [];
                for (let i = 0; i < rules.length; i++) {
                    const {host} = rules[i],
                        {result}: app_response = await http_request(
                            'external',
                            props,
                            undefined,
                            `/v1/datacenter/${datacenter_name}/externaldomain?cluster=${application_detail.clusterName}`,
                            1,
                            user_info.role,
                            undefined,
                            '',
                            '',
                            {internalDomains: [host]},
                            undefined,
                            true,
                            true
                        ) as app_response || {};
                    if (result) {
                        new_rules.push({
                            ...rules[i],
                            internal_domain: host,
                            external_domain: result[host]
                        })
                    }
                }
                set_item_selected({
                    rules: new_rules,
                    rules_title: ['internal_domain', 'external_domain', 'path', 'serviceName', 'servicePort'],
                    name,
                    namespace,
                    creationTimestamp,
                    labels,
                    annotations,
                    loadBalancer: ingress,
                    app_cluster: application_detail.clusterName,
                    app_namespace: application_detail.namespaceName,
                });
            }
        };

        const workload_column: ColumnsType<object> = [
            {
                title: 'Name',
                key: 'name',
                dataIndex: 'name',
                sorter: (a: any, b: any) => {
                    const str_a: string = a?.name || '', str_b: string = b?.name || '';
                    return str_a.localeCompare(str_b);
                },
                render: (val: string) => {
                    return val ? {children: val, props: {'data-title': 'name'}} : {}
                }
            }, {
                title: 'Type',
                key: 'type',
                dataIndex: 'type',
                sorter: (a: any, b: any) => {
                    const str_a: string = a?.type || '', str_b: string = b?.type || '';
                    return str_a.localeCompare(str_b);
                },
                render: (val: string) => {
                    return val ? {children: val, props: {'data-title': 'Type'}} : {}
                }
            }, {
                title: 'Image',
                key: 'imageName',
                dataIndex: 'imageName',
                sorter: (a: any, b: any) => {
                    const str_a: string = a?.imageName || '', str_b: string = b?.imageName || '';
                    return str_a.localeCompare(str_b);
                },
                render: (val: string[]) => {
                    return val ? {
                        children: val.map((item: string) => <div key={item}><Typography.Text
                            copyable={{text: item}}>{item}</Typography.Text></div>),
                        props: {'data-title': 'Image'}
                    } : {}
                }
            }, {
                title: 'Router',
                key: 'ingressName',
                dataIndex: 'ingressName',
                sorter: (a: any, b: any) => {
                    const str_a: string = a?.ingressName || '', str_b: string = b?.ingressName || '';
                    return str_a.localeCompare(str_b);
                },
                render: (item: string[]) => {
                    return item ? {
                        children: item?.map((val: string) => (
                            <Typography.Text key={val} copyable={{text: val}}>
                                <a
                                    href={'##'}
                                    rel="noopener noreferrer"
                                    onClick={(e: React.MouseEvent<HTMLElement>) => {
                                        e.preventDefault();
                                        open_router_modal(val);
                                    }}
                                >{val}</a>
                            </Typography.Text>
                        )) || '',
                        props: {'data-title': 'router'}
                    } : {}
                }
            }, {
                title: 'Scale(Ready/Total)',
                key: 'ready',
                dataIndex: 'ready',
                sorter: (a: any, b: any) => {
                    const str_a: string = a?.ready || '', str_b: string = b?.ready || '';
                    return str_a.localeCompare(str_b);
                },
                render: (val: string) => {
                    return val ? {children: val, props: {'data-title': 'router'}} : {}
                }
            }, {
                title: 'Age',
                key: 'age',
                dataIndex: 'age',
                sorter: (a: any, b: any) => {
                    const str_a: string = a?.age || '', str_b: string = b?.age || '';
                    return str_a.localeCompare(str_b);
                },
                render: (val: string) => {
                    return val ? {children: val, props: {'data-title': 'Age'}} : {}
                }
            }, {
                title: formatMessage({id: 'operation'}),
                key: 'action',
                width: 100,
                fixed: "right",
                render: (item: any) => item?.type ? {
                    children: (
                        <Dropdown
                            disabled={!operation_able[item?.type]}
                            overlay={(
                                <Menu className="small_dropdown setting-dropdown">
                                    <Menu.Item>
                                        <div className="pointer hover" onClick={() => {
                                            set_modal_data({
                                                title: 'scale',
                                                visible: true,
                                                cancel_btn: true,
                                                ok_btn: true,
                                                is_scale: true
                                            });
                                            set_scale_number(Number(item['up-to-date']) || 0)
                                        }}>
                                            <Button className="plain_button w-100">
                                                <FormattedMessage id="scale"/>
                                            </Button>
                                        </div>
                                    </Menu.Item>
                                    <Menu.Item>
                                        <div className="pointer hover" onClick={async () => {
                                            set_modal_data({
                                                title: 'view',
                                                visible: true,
                                                is_yaml: true,
                                                cancel_btn: true,
                                                yaml_data: 'Loading...'
                                            });
                                            const {data}: any = await worker_fetch({
                                                url: `/v1/datacenter/${datacenter_name}/cluster/${application_detail.clusterName}/namespace/${application_detail.namespaceName}/router/${item.name}`,
                                                method: 0,
                                                props: {formatMessage, history},
                                                datacenter_name
                                            }) || {};
                                            set_modal_data({
                                                title: 'view',
                                                visible: true,
                                                is_yaml: true,
                                                // cancel_btn: true,
                                                yaml_data: data?.Content || 'Loading failed'
                                            });
                                        }}>
                                            <Button className="plain_button w-100">
                                                <FormattedMessage id="view_in_yaml"/>
                                            </Button>
                                        </div>
                                    </Menu.Item>
                                </Menu>
                            )}
                            trigger={['click']} placement="bottomCenter">
                            <Button
                                className="plain_button d-flex align-items-center justify-between"
                                disabled={!operation_able[item?.type]}
                                onClick={() => set_table_item_selected(item)}
                            >
                                <MoreOutlined/>
                            </Button>
                        </Dropdown>
                    ),
                    props: {'data-title': 'Operation'}
                } : {}
            }
        ];

        return (
            <TableListModalContext.Provider value={[table_list_modal, set_table_list_modal]}>
                <TableListModal/>
                <Col className="px-20 mt-20">
                    <Row>
                        {/*<Col span={24} className={'back-to'}>*/}
                            {/*<Link to={'/applications'}>*/}
                                {/*<LeftOutlined/>*/}
                                {/*<FormattedMessage id={'applications'}/>*/}
                            {/*</Link>*/}
                        {/*</Col>*/}
                        <Col sm={24} className={'mb-10'}><BreadCrumb/></Col>
                        <Col sm={24}>
                            <Row className="card box_rounded card_bg operations">
                                <Col sm={24}>
                                    <Row align="middle">
                                        <Col sm={24}>
                                            <div className="card_title no_color big_font" style={{top: '-6px'}}>
                                                <FormattedMessage id="Application"/>
                                                {/*&nbsp;&nbsp;*/}
                                                {/*{application_selected.serviceInstanceName || ''}*/}
                                            </div>
                                        </Col>
                                        <Col sm={24}>
                                            <div className="card_title_desc no_color small_font"><FormattedMessage
                                                id="applications_desc"/></div>
                                        </Col>
                                    </Row>
                                    <Row className="mt-5">
                                        <Fragment>{select_menu}</Fragment>
                                    </Row>
                                </Col>
                            </Row>
                            <Row className="mt-20">
                                <Col xs={24} md={10} lg={7} xxl={5}>
                                    <Row className="detail-card">
                                        <Col span={24} className={'detail-card-img'}>
                                            <img src={application_detail?.icon || book} alt=""/>
                                        </Col>
                                        <Col span={24} className={'detail-card-info'}>
                                            <Skeleton loading={!application_detail} paragraph={{rows: 5}}>
                                                <Row>
                                                    <Col span={24} className="info-name text-ellipsis">
                                                        {application_selected?.serviceName || ' '}
                                                    </Col>
                                                    <Col span={24} className={'info-status'}>
                                                        <div>
                                                            <span className={'font-w-5'}>Instance Status:</span>
                                                            <span
                                                                className={`btn-status ${return_color(application_selected?.status || '')}`}>
                                                            {application_status[(application_selected?.status || '').toLowerCase()] || '---'}
                                                        </span>
                                                        </div>
                                                        <div>
                                                            <span className={'font-w-5'}>Deploy Status:</span>
                                                            <span
                                                                className={`btn-status ${return_color(application_detail?.status || '')}`}>
                                                            {application_status[(application_detail?.status || '').toLowerCase()] || '---'}
                                                        </span>
                                                        </div>
                                                    </Col>
                                                    <Col sm={24} className={'info-intro'}>
                                                        {application_detail?.description || ' '}
                                                    </Col>
                                                    <Col span={24} className={'info-chart'}>
                                                        <div className={'info-id'}>
                                                            <span
                                                                className={'font-w-5'}>Service Instance ID:&nbsp;&nbsp;</span>
                                                            <Typography.Text
                                                                copyable={{text: application_detail?.appServiceInstanceId}}>
                                                                {application_detail?.appServiceInstanceId || '***'}
                                                            </Typography.Text>
                                                        </div>
                                                        <p className={'text-ellipsis'}
                                                           title={application_detail?.clusterName || ''}>
                                                        <span className={'font-w-5'}>
                                                            <FormattedMessage id={'cluster'}/>:&nbsp;&nbsp;
                                                        </span>
                                                            {application_detail?.clusterName || ' '}
                                                        </p>
                                                        <p className={'text-ellipsis'}
                                                           title={application_detail?.workspaceName || ''}>
                                                        <span className={'font-w-5'}>
                                                            <FormattedMessage id={'workspace'}/>:&nbsp;&nbsp;
                                                        </span>
                                                            {application_detail?.workspaceName || ' '}
                                                        </p>
                                                        <p className={'text-ellipsis'}
                                                           title={application_detail?.namespaceName || ''}>
                                                        <span className={'font-w-5'}>
                                                            <FormattedMessage id={'namespace'}/>:&nbsp;&nbsp;
                                                        </span>
                                                            {application_detail?.namespaceName || ' '}
                                                        </p>
                                                        <p className={'text-ellipsis'}
                                                           title={application_detail?.chartname || ''}>
                                                        <span className={'font-w-5'}>
                                                            Chart Name:&nbsp;&nbsp;
                                                        </span>
                                                            {application_detail?.chartname || ' '}
                                                        </p>
                                                        <p className={'text-ellipsis'}
                                                           title={application_detail?.versionName || ''}>
                                                        <span className={'font-w-5'}>
                                                            Chart Version:&nbsp;&nbsp;
                                                        </span>
                                                            {application_detail?.versionName || ' '}
                                                        </p>
                                                    </Col>
                                                    <Col span={24} className={'info-time'}>
                                                        <p title={get_time(application_detail?.createdAt || '')}>
                                                            <span className={'font-w-5'}><FormattedMessage
                                                                id="create_time"/>(UTC+8):&nbsp;</span>
                                                            <span>{get_time(application_detail?.createdAt || '')}</span>
                                                        </p>
                                                        <p title={get_time(application_detail?.updatedAt || '')}>
                                                            <span className={'font-w-5'}><FormattedMessage
                                                                id="update_time"/>(UTC+8):&nbsp;</span>
                                                            <span>{get_time(application_detail?.updatedAt || '')}</span>
                                                        </p>
                                                    </Col>
                                                </Row>
                                            </Skeleton>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col xs={24} md={14} lg={17} xxl={19} className={'detail-right'}>
                                    <Row className={'p-20 detail-card'}>
                                        <Col span={24} className={'detail-right-top'}>
                                            <div className={'detail-name'}>
                                                <span
                                                    className={'detail-right-name text-ellipsis'}>{application_selected?.serviceInstanceName || '---'}</span>
                                            </div>
                                            <div className={'detail-btns'}>
                                                <Button
                                                    className={'detail-btn'}
                                                    disabled={!status_return_boolean(application_detail)}
                                                    type={status_return_boolean(application_detail) ? 'primary' : 'default'}
                                                    onClick={() => {
                                                        set_modal_data({
                                                            title: 'redeploy',
                                                            visible: true,
                                                            cancel_btn: true,
                                                            ok_btn: true,
                                                            is_confirm: true,
                                                            confirm_content: <FormattedMessage id={'sure_redeploy'}/>
                                                        })
                                                    }}
                                                ><FormattedMessage id={'redeploy'}/></Button>
                                                <Button
                                                    className={'detail-btn'}
                                                    disabled={!status_return_boolean(application_detail)}
                                                    type={status_return_boolean(application_detail) ? 'primary' : 'default'}
                                                    onClick={() => {
                                                        set_modal_data({
                                                            title: start_stop(app_actualStatus),
                                                            visible: true,
                                                            cancel_btn: true,
                                                            ok_btn: true,
                                                            is_confirm: true,
                                                            confirm_content: <FormattedMessage
                                                                id={`sure_${start_stop(app_actualStatus)}`}/>
                                                        })
                                                    }}
                                                >
                                                    <FormattedMessage id={start_stop(app_actualStatus)}/>
                                                </Button>
                                                <Button
                                                    className={'detail-btn'}
                                                    disabled={!(status_return_boolean(application_detail) && can_update)}
                                                    type={(status_return_boolean(application_detail) && can_update) ? 'primary' : 'default'}
                                                    onClick={() => {
                                                        get_version_list();
                                                        set_modal_data({
                                                                title: 'update',
                                                                visible: true,
                                                                is_confirm: true,
                                                                // is_update: true,
                                                                ok_btn: true,
                                                                cancel_btn: true,
                                                                confirm_content: <FormattedMessage id={'sure_update'}/>
                                                            }
                                                        )
                                                    }}
                                                ><FormattedMessage id={'update'}/></Button>
                                                <Button
                                                    className={'detail-btn'}
                                                    disabled={!application_detail}
                                                    type={application_detail ? 'primary' : 'default'}
                                                    onClick={load_app_list}
                                                ><FormattedMessage id={'refresh'}/></Button>
                                            </div>
                                        </Col>
                                        <Skeleton loading={!application_detail} title={false} paragraph={{rows: 3}}>
                                            {application_detail?.externalPortalUrl?.length > 0 &&
                                            <Col span={24} className={'detail-right-center'}>
                                                <div className={'center-label'}>Access URLs:</div>
                                                <div className={'center-list'}>{
                                                    application_detail?.externalPortalUrl?.map((item: string) => (
                                                        <Typography.Text
                                                            key={item}
                                                            copyable={{text: item}}
                                                            style={{display: 'inline-block'}}
                                                        >
                                                            <u title={item}
                                                               onClick={() => window.open(`https://${item}` || '', '_blank')}>{item}</u>
                                                        </Typography.Text>
                                                    ))
                                                }</div>
                                            </Col>}
                                            {/*<Col span={24} className={'detail-right-center'}>*/}
                                            {/*<div className={'center-label'}>Internal Portal Url:</div>*/}
                                            {/*<div className={'center-list'}>{*/}
                                            {/*application_detail?.internalPortalUrl?.map((item: string) => (*/}
                                            {/*<Typography.Text key={item} copyable={{text: item}}>*/}
                                            {/*<u title={item}>{item}</u>*/}
                                            {/*</Typography.Text>*/}
                                            {/*))*/}
                                            {/*}</div>*/}
                                            {/*</Col>*/}
                                            {/*<Col span={24} className={'detail-right-center'}>*/}
                                            {/*<div className={'center-label'}>Service Instance Id:</div>*/}
                                            {/*<div className={'center-list'}>{application_detail?.appServiceInstanceId || '***'}</div>*/}
                                            {/*</Col>*/}
                                        </Skeleton>
                                        <Col span={24} className={'detail-right-center'}>
                                            <div className={'center-label'}>
                                                Workload:
                                                <SyncOutlined spin={reload_workload} onClick={() => set_reload(true)}/>
                                            </div>
                                        </Col>
                                        <Col span={24} style={{marginBottom: '30px', borderBottom: '1px solid #eee'}}>
                                            <Table
                                                rowKey={({name}: any) => name}
                                                columns={workload_column}
                                                dataSource={workload}
                                                size={'small'}
                                                showSorterTooltip={false}
                                                pagination={{defaultPageSize: 5}}
                                                // scroll={{x: 800}}
                                                expandable={{
                                                    expandedRowRender: (record: any) => expended_table(record),
                                                    expandIcon: ({expanded, onExpand, record}) => expanded ?
                                                        <DownOutlined onClick={e => onExpand(record, e)}/> :
                                                        <RightOutlined onClick={e => onExpand(record, e)}/>
                                                }}
                                            />
                                        </Col>
                                        <Col span={24} className={'detail-right-center'}>
                                            <div className={'center-label'}>Data Service:</div>
                                        </Col>
                                        <Col span={24}>
                                            <Table
                                                rowKey={({serviceInstanceId}: any) => serviceInstanceId}
                                                columns={data_service_column}
                                                dataSource={data_service_selected}
                                                size={'small'}
                                                showSorterTooltip={false}
                                                pagination={{defaultPageSize: 5}}
                                                // scroll={{x: 800}}
                                            />
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Modal
                        visible={modal_data?.visible}
                        title={formatMessage({id: modal_data?.title || 'title'})}
                        maskClosable={true}
                        onCancel={() => set_modal_data({visible: false})}
                        onOk={on_btn_click}
                        width={modal_data?.is_yaml ? "80vw" : 500}
                        footer={<div>
                            {modal_data?.cancel_btn &&
                            <Button onClick={() => set_modal_data({visible: false})}><FormattedMessage
                                id={'cancel'}/></Button>}
                            {modal_data?.ok_btn && modal_loading ?
                                <Button type='default' disabled><LoadingOutlined/></Button> :
                                <Button
                                    type='primary'
                                    onClick={on_btn_click}
                                ><FormattedMessage id={'ok'}/></Button>
                            }
                        </div>}
                    >
                        {modal_data?.is_yaml && <AceEditor
                            focus
                            style={{width: "100%"}}
                            mode="yaml"
                            value={modal_data?.yaml_data ? yaml.safeDump(modal_data.yaml_data) : formatMessage({id: 'empty'})}
                            theme="monokai"
                            name="template_file"
                            fontSize={18}
                            showPrintMargin={false}
                            showGutter={true}
                            wrapEnabled={true}
                            highlightActiveLine
                            readOnly={true}
                            setOptions={{
                                showLineNumbers: true,
                                tabSize: 2,
                            }}
                            editorProps={{$blockScrolling: true}}
                        />}
                        {modal_data?.is_update && <Row>
                            <Col span={24} className={'pb-10'}>
                                <FormattedMessage id={'version'}/>:
                            </Col>
                            <Col span={24}>
                                <Select
                                    style={{width: '100%'}}
                                    value={update_version}
                                    onChange={(e: string) => set_update_version(e)}
                                >{version_list?.map((item: version_item_type) => (
                                    version_compare(application_detail.versionName, item.chartversion) &&
                                    <Select.Option
                                        key={item.chartversion}
                                        value={item.chartversion}
                                    >{item.chartversion}</Select.Option>
                                ))}</Select>
                            </Col>
                        </Row>}
                        {modal_data?.is_confirm && <Row>
                            <Col span={24}>
                                        <span>
                                        {modal_data.confirm_content}
                                        </span>
                            </Col>
                        </Row>}
                        {modal_data?.is_scale && <Row>
                            <Col span={24} className={'pb-10'}>
                                Pods:
                            </Col>
                            <Col span={24}>
                                <Select
                                    style={{width: '100%'}}
                                    value={scale_number}
                                    onSelect={(e: number | string) => set_scale_number(Number(e))}
                                >{pods_arr.map((item: number) => (
                                    <Select.Option key={item} value={item}>{item}</Select.Option>
                                ))}</Select>
                            </Col>
                        </Row>}
                    </Modal>
                </Col>
            </TableListModalContext.Provider>
        );
    }
;

export default withRouter(injectIntl(ApplicationsDetail) as any);
